export { default } from "./ThankYouPopup.component";
